import Vue from 'vue'; 
import VueRouter from 'vue-router';
import HelloMartin from './components/HelloMartin';
import HelloWorld from './components/HelloWorld';

Vue.use(VueRouter);

// Define Routes
const routes = [
  { path: '/', component: HelloMartin, name: 'home' },
  {
    path: '/about',
    component: HelloWorld,
    name: 'about',
    props: { msg: 'This app was built using VueJS' }
  }
];

// Create Router
const router = new VueRouter({ mode: 'history', routes });

export default router;